import { version } from "../context/dataApplicationsContext"
import { dateVersion } from "../context/dataApplicationsContext"

export default function Footer() {
  
  return (
    <>
      <div className="footer-wrapper">
        <div className="footer-container">
          <p>Version {process.env.REACT_APP_VERSION} | {dateVersion}</p>
          <p>Copyright ©2025 | Designed by Matthieu LAUMET</p>
        </div>
      </div>
    </>
  )
}